import { connect } from 'react-redux';
import LK from '../../components/lk/LK';
import * as actions from '../../actions/lk';
import { getCount as getAnnouncementCount } from '../../actions/announcement';
import { layout } from '../../actions/layout';

const mapStateToProps = ({ lk, auth, layout, announcement }) => ({
  user: lk.data,
  photo: lk.photo,
  selfPhoto: lk.selfPhoto,
  rateList: lk.rateList,
  unreadMessages: lk.unreadMessages,
  unreadAnnouncements: announcement.unreadCount,
  mid: auth.mid,
  chats: lk.chats,
  isTeacher: auth.isTeacher,
  needChangePassword: auth.need_change_password,
  links: layout.links,
  scheduleToday: lk.scheduleToday
});

const mapDispatchToProps = dispatch => ({
  didMount: () =>
    dispatch(actions.lk())
    && dispatch(actions.photo())
    && dispatch(actions.selfPhoto())
    && dispatch(actions.rate())
    && dispatch(actions.unreadMessages())
    && dispatch(getAnnouncementCount())
    && dispatch(actions.getScheduleToday())
});

export default connect(mapStateToProps, mapDispatchToProps)(LK);
